import type { ConsensusRow } from '@api-response-types/consensus.response';
import type { IRowNode } from 'ag-grid-enterprise';

type ConsensusNode = IRowNode<ConsensusRow>;

export function isConsensusGroupNode(node: ConsensusNode): boolean {
  return Boolean(node.data?.hasChildren);
}

export function isGrandTotalRoot(node: ConsensusNode): boolean {
  return Object.keys(node.data?.dimensions ?? {}).length === 0;
}
